<template>
  <div class="account">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
    <input type="password" style="display: none;">
      <div class="cross">
        <div class="line"></div>
        <div class="info">账号设置</div>
      </div>

      <el-form-item label="账号：">
        <!-- <el-input v-model="ruleForm.entCode">{{ruleForm.entCode}}</el-input> -->
        {{username}}
      </el-form-item>
      <!-- <el-form-item label="原始密码：" prop="oldPassword">
        <el-input v-model="ruleForm.oldPassword" show-password></el-input>
      </el-form-item>-->
      <!-- <input type="password"  style="display:none"> -->
       <!-- <input type="password" name="txtPassword" style="display:none"> -->
      <el-form-item label="新密码：" prop="password">
        <el-input v-model="ruleForm.password"  :type="inputType" autocomplete="off" placeholder="请输入新密码（8~16个字符）" @focus="inputType='password'"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码：" prop="surePassword">
        <el-input v-model="ruleForm.surePassword" :type="inputType"  autocomplete="off" placeholder="请再次输入密码（8~16个字符）" @focus="inputType='password'"></el-input>
      </el-form-item>
      <el-form-item label="关联51账号：" prop="r51Username">
        <el-input v-model="ruleForm.r51Username" placeholder="请输入51账号（11个字符）"></el-input>
      </el-form-item>
      <el-form-item label="App ID：" prop="r51Appid">
        <el-input v-model="ruleForm.r51Appid" placeholder="请输入App ID"></el-input>
      </el-form-item>
      <el-form-item label="Key：" prop="r51Key">
        <el-input v-model="ruleForm.r51Key" placeholder="请输入Key"></el-input>
      </el-form-item>

      <el-form-item class="marginTop">
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <!--<el-button @click="resetForm('ruleForm')">取消</el-button>-->
      </el-form-item>

      <div class="cross">
        <div class="line"></div>
        <div class="info">关联小程序</div>
      </div>

      <el-form-item class="plaintext" label="小程序名称：">{{ruleForm.appletName}}</el-form-item>
      <el-form-item class="plaintext" label="小程序ID：">{{ruleForm.appletAppid}}</el-form-item>
      <el-form-item class="plaintext" label="版本号：">{{ruleForm.appletVersion}}</el-form-item>

      <div class="cross marginTop">
        <div class="line"></div>
        <div class="info">微信支付商户设置</div>
      </div>

      <!-- <el-form-item class="plaintext" label="商户名称：">{{ruleForm.wxpayName}}</el-form-item> -->
      <el-form-item class="plaintext" label="appid：">{{ruleForm.wxpayAppid}}</el-form-item>
      <el-form-item class="plaintext" label="secret：">{{ruleForm.wxpaySecret}}</el-form-item>
    </el-form>
  </div>
</template>

<script>
  import GlobalUtil from "../../utils/globalUtil";

  export default {
    data() {
      var validatorPassword = (rule, value, callback) => {
        if (value) {
          let ls = 0
          if (value.match(/([a-z])+/)) {
            ls++;
          }
          if (value.match(/([0-9])+/)) {
            ls++;
          }
          if (value.match(/([A-Z])+/)) {
            ls++;
          }
          if (value.match(/[^a-zA-Z0-9]+/)) {
            ls++;
          }
          if (value.length < 8 || value.length > 16) {
            return callback(new Error('请输入8-16位'))
          } else if (ls < 2) {
            return callback(new Error('密码必须是字母大写，字母小写，数字，特殊字符中任意两种组合，请重新设置！'))
          }
          callback()
        } else {
          callback()
        }
      }

      var validatorsurePassword = (rule, value, callback) => {
        if (value || this.ruleForm.password) {
          if (!value || !value.trim()) {
            return callback(new Error("请再次输入密码"));
          } else if (value !== this.ruleForm.password) {
            return callback(new Error("两次输入密码不一致!"));
          }
          callback();
        } else {
          callback();
        }
        // callback(new Error("请再次输入密码"));
      };

      var validatorUserName = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入51账号'));
        } else if (!(/^1[123456789]\d{9}$/.test(value))) {
          callback(new Error('51账号有误，请重填'));
        } else {
          callback();
        }
      };
      var validatorAppid = (rule, value, callback) => {
        let reg = /^[0-9]*$/g
        if (value) {
          // if (value.length != 6) {
          //   return callback('请输入6位纯数字')
          // } else if (!reg.test(value)) {
          //   return callback('请输入6位纯数字')
          // }
          callback()
        } else {
          return callback('请输入APPID')
        }

      };

      var validatorrKey = (rule, value, callback) => {
        let reg = /^[0-9a-zA-Z]*$/g
        if (value) {
          if (value.length != 7) {
            return callback('请输入7位')
          } else if (!reg.test(value)) {
            return callback('请输入正确的KEY码')
          }
          callback()
        } else {
          return callback(new Error('请输入Key'))
        }
      };
      return {
        inputType:'text',
        ruleForm: {},
        rules: {
          // entCode: [
          //   { required: true, message: "请输入正确的账号", trigger: "blur" }
          // ],
          // oldPassword: [
          //   {min: 3, max: 15, message: "请输入3-15个字符", trigger: "blur"}
          // ],
          password: [
            {trigger: "blur", validator: validatorPassword}
          ],
          surePassword: [
            // { required: true, message: "请确定密码", trigger: "blur" },
            {validator: validatorsurePassword, trigger: "blur"},
          ],
          r51Username: [
            {required: true, validator: validatorUserName, trigger: "blur"},
          ],
          r51Key: [
            {required: true, /*validator: validatorrKey,*/ trigger: "blur"},
          ],
          r51Appid: [{required: true, validator: validatorAppid, trigger: "blur"}]
        },
        username: GlobalUtil.readCookie('username1')
      };
    },
    methods: {
      // 提交
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.accountSetting()
          } else {
            // this.$message.error('请填写表单')
            return false;
          }
        });
      },
      // 重置
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      // 获取信息
      getAccountInfo() {
        this.$axios.get(this.$url.getAccountSetting).then(res => {
          console.log("我是信息", res);
          if(res.code == 0){
            if(!res.data.wxpayName){
              res.data.wxpayName= '-'
            }
          this.ruleForm = res.data;

          }
        });
      },
      // 修改信息
      accountSetting() {
        //验证51配置是否正确
        this.$axios.post(this.$url.verify51True, this.ruleForm).then(res => {
          if (res.code === 0) {
            this.ruleForm.password = this.ruleForm.password || null;
            this.$axios.post(this.$url.accountSetting, this.ruleForm).then(res => {
              if (res.code === 0) {
                this.$message.success('修改成功')
              }
            });
          }
        });
      }
    },
    created() {
      // 获取信息
      this.getAccountInfo();
    }
  };
</script>

<style lang='less' scoped>
  .account {
    height: 1000px;
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    padding: 24px 30px;

    ::v-deep .el-input {
      width: 320px;

      ::v-deep .el-input__inner {
        height: 36px !important;
      }
    }

    .cross {
      display: flex;
      box-sizing: border-box;
      align-items: center;
      margin-bottom: 30px;

      .line {
        width: 3px;
        height: 19px;
        background: rgba(102, 102, 102, 1);
        margin-right: 5px;
      }

      .info {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
    }

    .plaintext {
      ::v-deep .el-form-item__label,
      ::v-deep .el-form-item__content {
        height: 18px !important;
        line-height: 18px;
      }

      margin-bottom: 16px !important;
      height: 18px !important;
    }

    .marginTop {
      margin-top: 30px;
    }
  }
</style>
